import SignIn from "@/modules/auth/SignIn";
import { ROUTES } from "../constants/routes";
import { IRoute } from "../routes";

const authRouterList: IRoute[] = [
  {
    path: ROUTES.AUTH.LOGIN,
    element: SignIn,
  },
  // {
  //   path: ROUTES.AUTH.FORGOT_PASSWORD,
  //   element: null,
  // },
  // {
  //   path: ROUTES.AUTH.RESET_PASSWORD,
  //   element: null,
  // },
];

export default authRouterList;
